//Facility Montirong Settings.

import { makeRequest } from './dtServices'
import i18n from '../i18n'

export interface IAppSettingsParams {
    applicationName?: string
    orgId: string
}

export interface IHierarchy {
    entityTemplateId: string
    id: string
    name: string
}
export interface ISettingsResponse<T> {
    applicationName: string
    appSettings: T
    hierarchy: IHierarchy[]
}

export const updateApplicationSettings = async <T>(
    orgId: string,
    applicationName: string,
    payload: T,
): Promise<void> => {
    await makeRequest<void, T, IAppSettingsParams>(
        'post',
        `/settings`,
        payload,
        {
            applicationName,
            orgId,
        },
        i18n.t('savedSuccess'),
        i18n.t('errorSavingSettings'),
    )
}

export const getApplicationSettings = async <T>(
    orgId: string,
    applicationName: string,
): Promise<ISettingsResponse<T>> => {
    return makeRequest<ISettingsResponse<T>, null, IAppSettingsParams>(
        'get',
        `/settings`,
        null,
        {
            applicationName,
            orgId,
        },
        '',
        '',
    )
}
